import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {SigninComponent} from './signin/signin.component';
import {CreateclientComponent} from './createclient/createclient.component';
import { CreateadminComponent } from './createadmin/createadmincomponent';
import { CreateuserComponent } from './createuser/createuser.component';
import {FgpasswordComponent} from './fgpassword/fgpassword.component';
import {CreatepatientComponent} from './createpatient/createpatient.component';
import {SearchComponent} from './search/search.component';
import {HomeComponent} from './home/home.component';
import { UserprofileComponent } from './userprofile/userprofile.component';
import { AllusersComponent } from './allusers/allusers.component';
import { ReportComponent } from './report/report.component';

const routes: Routes = [{component: SigninComponent, path: ''},
  {component: CreateclientComponent, path: 'cclient'},
  {component: CreateuserComponent, path: 'cuser'},
   {component: CreateadminComponent, path: 'cadmin'},
  {component: FgpasswordComponent, path: 'fgpass'},
  {component: CreatepatientComponent, path: 'cpatient'},
  {component: SearchComponent, path: 'clients/:uid/:email/:realRole'},
  {component: HomeComponent, path: 'home'},
  {component: UserprofileComponent, path: 'profile/:uid'},
  {component: AllusersComponent, path: 'consultants'},
  {component: ReportComponent, path: 'report/:uid'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
